var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"youtube-container"},[_c('div',{staticClass:"youtube-wrap"},[_c('iframe',{attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/"+_vm.props.data.content,"frameborder":"0","allowfullscreen":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }